import React from 'react'
import PropTypes from 'prop-types'
import { withCookieConsent } from 'LiveBoard/hocs'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { BoardSocialLinks } from 'LiveBoard/components/shared/BoardSocialLinks'
import { EmailDialog } from './EmailDialog'
import findKey from 'lodash/findKey'
import startCase from 'lodash/startCase'

import './style.css.scss'

class ShareBoard extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showBoardSocialLinks: false, showEmailDialog: false }
  }

  handleShare = (type) => {
    type == 'email'
      ? this.setState({ showEmailDialog: true, showBoardSocialLinks: false })
      : window.open(`${this.props.shareUrls[type]}${window.location.href}`)
  }

  handleOpen = () => {
    if(this.props.numberOfShareOptions == 1) {
      const shareType = findKey(this.props.config)
      this.handleShare(shareType)
    } else {
      this.setState({
        showBoardSocialLinks: !this.state.showBoardSocialLinks
      })
    }
    this.props.onCookieConsent()
    this.props.trackShareClick()
  }

  handleEmailShareSubmit = (values) => {
    this.props.onEmailShare(values, {invitationId: this.props.config.invitation_id})
  }

  closeEmailDialog = () => {
    this.setState({ showEmailDialog: false })
  }

  render() {
    const { themeColorHex, config, numberOfShareOptions, getTranslation } = this.props
    const { showEmailDialog, showBoardSocialLinks } = this.state
    const style = { color: showBoardSocialLinks ? themeColorHex : '' }

    return numberOfShareOptions > 0 && (
      <div className="share-board-container">
        <div className="share-button"
          style={style}
          onClick={this.handleOpen}>
          <span className="icon-share" />
          <label>{startCase(getTranslation(TRANSLATION_VALUE_KEYS.shareBoard))}</label>
        </div>
        { showBoardSocialLinks &&
          <BoardSocialLinks
            onShareClick={this.handleShare}
            config={config} /> }
        { showEmailDialog &&
          <EmailDialog
            themeColorHex={themeColorHex}
            onSubmit={this.handleEmailShareSubmit}
            onClose={this.closeEmailDialog} />}
      </div>
    )
  }
}

ShareBoard.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  trackShareClick: PropTypes.func.isRequired,
  onEmailShare: PropTypes.func.isRequired,
  shareUrls: PropTypes.object.isRequired,
  numberOfShareOptions: PropTypes.number.isRequired,
  onCookieConsent: PropTypes.func.isRequired
}

export default withCookieConsent(withTranslation(TRANSLATION_KEYS.mobileShareBoard)(ShareBoard))